import { EnhancedDialog } from 'components/enhanced/dialog/EnhancedDialog';
import EnhancedForm from 'components/enhanced/form/EnhancedForm';
import { IdentityField } from 'components/enhanced/form/fields/IdentityField';
import { TextFieldAdapter } from 'components/enhanced/form/adapters/text-inputs/TextFieldAdapter';
import toast from 'shared/utils/toast';
import { useTranslation } from 'react-i18next';
import { roleNameService } from '../api/role-name.service';
import { SectionHeader } from 'components/ui/typography';

export default function AddRoleNameDialog({
  open,
  setOpen,
  callback
}: {
  open: boolean;
  setOpen: (value) => any;
  callback?: any;
}) {
  const { t } = useTranslation();

  const handleClose = () => {
    setOpen(false);
  };

  const onSubmit = (values) => {
    roleNameService.add({ ...values }).then(() => {
      toast.success(t('pages.role-names.list.add-dialog.success'));
      handleClose();
      if (callback) callback();
    });
  };

  return (
    <EnhancedDialog
      open={open}
      onClose={handleClose}
      title={t('pages.role-names.list.add-dialog.title')}
      subTitle={t('pages.role-names.list.add-dialog.subtitle')}
      submitLabel={t('actions.save', 'Salva')}
      cancelLabel={t('actions.reset', 'Annulla')}
      maxWidth="md"
      submitButtonProps={{
        type: 'submit',
        form: 'addCostLink'
      }}>
      <EnhancedForm
        onSubmit={onSubmit}
        formId="addCostLink"
        hideControls
        autoStyleLayout={true}
        columns={3}>
        <SectionHeader title={t('pages.role-names.list.add-dialog.description-area')} gridSpan />
        <IdentityField
          gridSpan={3}
          name="code"
          component={TextFieldAdapter}
          label={t('global.code')}
          type="text"
          tooltip="Spazio per inserire il nome identificativo o l'identificativo alfanumerico del ruolo"
        />
        <SectionHeader
          title={t('pages.role-names.list.add-dialog.cost-area')}
          subtitle={t('pages.role-names.list.add-dialog.cost-area-subtitle')}
          gridSpan
        />
        <IdentityField
          name="fte"
          component={TextFieldAdapter}
          label={t('entities.role_name.fte')}
          type="number"
          tooltip="Full-Time Equivalent: Indica la percentuale di tempo pieno della risorsa. 1.0 equivale a un lavoratore a tempo pieno, 0.5 a un part-time al 50%"
        />
        <IdentityField
          name="monthly_hours"
          component={TextFieldAdapter}
          label={t('entities.role_name.monthly_hours')}
          type="number"
          tooltip="Il numero totale di ore di lavoro richieste per questo ruolo nell'arco di un mese."
        />
        <IdentityField
          name="monthly_cost"
          component={TextFieldAdapter}
          label={t('entities.role_name.monthly_cost')}
          type="number"
          tooltip="Il budget o la spesa stimata prevista ogni mese per coprire questo specifico ruolo."
        />
      </EnhancedForm>
    </EnhancedDialog>
  );
}
